/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Faq_3_QuestionInputs */

const en_svc_agents_faq_3_question = /** @type {(inputs: Svc_Agents_Faq_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does it cost to build a custom AI agent?`)
};

const lv_svc_agents_faq_3_question = /** @type {(inputs: Svc_Agents_Faq_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cik maksā pielāgota AI aģenta izstrāde?`)
};

/**
* | output |
* | --- |
* | "How much does it cost to build a custom AI agent?" |
*
* @param {Svc_Agents_Faq_3_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_faq_3_question = /** @type {((inputs?: Svc_Agents_Faq_3_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Faq_3_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_faq_3_question(inputs)
	return en_svc_agents_faq_3_question(inputs)
});